import { MessageFormatElement } from 'react-intl'
import { TranslationKey } from './index'

const translations:
| Record<TranslationKey, string>
| Record<TranslationKey, MessageFormatElement[]> = {
  'aboutus.customers': 'хэрэглэгч',
  'aboutus.employees': 'ажилтан',
  'aboutus.projects': 'нийгмийн хариуцлагын төслүүдийн хөрөнгө оруулалт',
  'aboutus.sdg': 'НҮБ-ын Тогтвортой хөгжлийн зорилгуудыг хангагч байгууллага',
  'aboutus.title': 'МОБИКОМ ГРУППТ ТАВТАЙ МОРИЛ',
  'aboutus.text':
    'Монголын харилцаа холбоо, мэдээллийн технологийн тэргүүлэгч Мобиком групп нь үүрэн холбоо, улс хоорондын холбоо, өндөр хурдны интернэт, цахим төлбөрийн шийдэл, сансрын холбоо, сүлжээний дэд бүтэц, дата төв, контент болон видео стрийминг үйлчилгээ, дижитал контент зэрэг харилцаа холбоо, мэдээллийн технологийн цогц үйлчилгээг хувь хүн, албан байгууллагуудад үзүүлж байна. Мобиком групп нь Дижитал хувьслыг түүчээлж, IoT, AI, 5G технологийг Монголдоо амжилттай нутагшуулж байна.',
  'aboutus.iso1': 'Чанарын менежментийн тогтолцоо',
  'aboutus.iso2': 'Мэдээллийн аюулгүй байдлын менежментийн тогтолцоо',
  'aboutus.iso3':
    'Хөдөлмөрийн эрүүл мэнд, аюулгүй байдлын менежментийн тогтолцоо',
  'aboutus.subs': 'охин компани',
  'aboutus.management.biography': 'Намтар',
  'aboutus.management.subsidiaryDirectors':
    'Групп компаниудын гүйцэтгэх захирлууд',
  'aboutus.management.groupDirectors': 'Гүйцэтгэх удирдлагын баг',
  'apartment.door': 'Байрны тоот',
  accept: 'Зөвшөөрөх',
  acceptTermsOfService: 'Үйлчилгээний нөхцөлийг зөвшөөрнө үү',
  address:
    'Монгол Улс, Улаанбаатар хот, Сүхбаатар дүүрэг, 1-р хороо, ЮНЕСКО-ийн гудамж - 28, МПМ Цогцолбор',
  'agreement.terms': 'Гэрээний нөхцөлтэй танилцах',
  all: 'Бүгд',
  amountDue: 'Төлөх дүн',
  'app.title': 'Хэрэглээг хялбарчлах аппликэйшнууд',
  apporcard: 'Апп болон картаар',
  back: 'Буцах',
  'bill.back': 'Төлбөрлүү буцах',
  'bill.check': 'Төлбөрийн үлдэгдэл шалгах',
  'bill.captcha': 'Captcha код',
  'bill.captcha.placeholder': 'Дээрх кодыг оруулна уу',
  'bill.captcha.invalid': 'Captcha код буруу байна',
  'bill.creditBalance': 'Илүү төлөлт',
  'bill.mobicom': 'Мобиком',
  'bill.mobinet': 'Өрхийн интернэт',
  'bill.noPaymentDue': 'Одоогоор төлөх дүнгүй байна',
  'bill.verify': 'Баталгаажуулах',
  'bill.wifiCard': 'Wifi карт авах',
  'bill.wifiCard.warning':
    'Wifi карт авах утасны дугаараа оруулснаар тухайн дугаарыг цэнэглэх боломжтой картууд харагдана',
  'bill.Mnp75': 'MNP75 үйлчилгээ',
  'bill.Mnp75.warning':
    'MNP75 нэгж авах утасны дугаараа оруулснаар тухайн дугаарыг цэнэглэх боломжтой нэгжийн картууд харагдана',
  'bill.Voo': 'VOO үйлчилгээ',
  'bill.warning': '1000 төгрөгөөс доош дүнтэй гүйлгээ хийх боломжгүй',
  billion: 'тэрбум',
  branch: 'салбар',
  branches: 'Салбарын байршил',
  'branches.type': 'Салбарын төрөл',
  buy: 'Худалдан авах',
  city: 'Хот/Аймаг',
  clear: 'Арилгах',
  district: 'Дүүрэг/Сум',
  quarter: 'Хороо/Баг',
  apartment: 'Байр',
  bylist: 'Жагсаалтаар',
  bymap: 'Газрын зурагаар',
  cardOptions: 'Картын сонголтууд',
  ces: 'Сэтгэгдэл',
  'ces.reason': 'Яагаад хүндрэлтэй байсан шалтгаан бичээрэй',
  'ces.subtitle':
    'Сэтгэлдлээ бидэнтэй хуваалцан цаашдын хөгжилд хувь нэмрээ оруулаарай',
  'ces.title': 'Мобиком аппликейшнаас үйлчилгээ авахад хялбар байсан уу?',
  change: 'Өөрчлөх',
  chatGPT_button: 'AI бот-оос асууя?',
  check: 'Шалгах',
  choose: 'Сонгох',
  chooseCard: 'Цэнэглэгч картуудаас сонгох',
  clickHereToType: 'Энд дараад бичээрэй',
  close: 'Хаах',
  continue: 'Үргэлжлүүлэх',
  confirm: 'Зөвшөөрөх',
  complete: 'Дуусгах',
  creditControl: 'Хэрэглээ хязгаарлах түвшин',
  datakey: 'дата',
  'dan.title': 'Хэрэглэгчийн танин баталгаажуулах',
  'dan.invalid_user': 'Хэрэглэгчийн мэдээлэл зөрүүтэй байна.',
  'dan.announce':
    'Бид таныг танин баталгаажуулахын тулд e-mongolia системрүү нэвтрэх гэж байна',
  'dan.verify': 'Баталгаажуулах',
  'dan.announce.stars':
    'Та өөрийн e-Mongolia цахим бүртгэлээр нэвтэрч хүүхдийн эцэг/эх мөн болохоо баталгаажуулна уу',
  'dan.requirement':
    'Монгол улсын иргэний үнэмлэхтэй хэрэглэгч ашиглах боломжтой.',
  data: 'Дата багц',
  'data.warning':
    'Дата авах утасны дугаараа оруулснаар тухайн дугаарыг цэнэглэх боломжтой датанууд харагдана. \n/Мөн Манай Интернэтийн дугаараа оруулан нэмэлт дата багцаар цэнэглэх боломжтой./',
  day: 'хоног',
  days: 'хоног',
  digitalCard: 'Дижитал карт',
  email: 'Цахим шуудан',
  'email.check': 'Та имэйл хаягаа шалгана уу.',
  'email.registration': 'И-мэйл бүртгүүлэх',
  'email.verification': 'И-мэйл баталгаажуулах',

  'email.verification2': 'И-мэйл хаягаар баталгаажуулах',
  error: 'Амжилтгүй',
  'error.addressError': 'Хаягийн мэдээлэл гүйцэд оруулна уу.',
  'error.emailError': 'Имэйл формат буруу байна',
  'error.isdnError': 'Утасны дугаар буруу байна',
  'error.outstock': 'Уучлаарай, энэ бараа онлайн дэлгүүрт байхгүй тул та өөрт ойрхон салбарт хандана уу. [Энд] дарна уу',
  'error.registerError': 'регистрийн дугаар буруу байна',
  'error.requiredFields':
    'Зайлшгүй бөглөх шаардлагатай талбаруудыг гүйцэд бөглөнө үү',
  'error.requiredFields2': 'Талбаруудыг гүйцэд бөглөнө үү',
  'error.corpRegister.empty': 'Байгууллагын регистэр буруу байна.',
  'error.cyrillError': 'Та мэдээллийг криллээр үнэн зөв бичнэ үү.',
  'COX.name': 'СӨХ нэр',
  'COX.contact1': 'СӨХ холбогдох дугаар',
  'COX.contact2': 'СӨХ холбогдох дугаар 2',
  registrationExpire: 'Бүртгэл дуусахад',
  expire: 'Урамшуулал дуусахад',
  'request.toSend': 'Хүсэлт илгээх',
  'request.sent': 'Таны хүсэлтийг хүлээж авлаа',
  'request.failed': 'Хүсэлт амжилтгүй.',
  'request.success': 'Таны дугаар захиалга амжилттай хийгдлээ',
  'request.network': 'Сүлжээ оруулах хүсэлт',
  'request.service': 'Өрхийн интернэт тавиулах захиалга',
  'footer.aboutus': 'Бидний тухай',
  'footer.contact': 'Холбоо барих',
  'footer.future': 'Ирээдүйг сэтгэл\nдогдлон хүлээж \nбайна уу?',
  'footer.jobs': 'Нээлттэй ажлын байр',
  'footer.join': '\nБидэнтэй нэгдэх үү?\n\n',
  'footer.support': 'Танд тусалъя',
  generalProvs: 'Ерөнхий заалт',
  groupcompanies: 'Групп компаниуд',
  'handset.color': 'Өнгө',
  'handset.size': 'Хэмжээ',
  'handset.specs': 'Техникийн үзүүлэлт',
  'handset.storage': 'Багтаамж',
  'handset.title': 'Гар утас',
  'help.title': 'Танд тусламж хэрэгтэй юу?',
  'legend.legend': 'Таних тэмдэг',
  'legend.wifi': 'Wi-fi',
  'legend.quality': 'Сүлжээний чанар',
  'legend.good': 'Сайн',
  'legend.medium': 'Дунд',
  'history.timeline': 'Түүхэн замнал',
  homebroadbandRequest: 'Өрхийн интернэт тавиулах захиалга өгөх',
  homebroadbandWarning:
    'Хэрэв дээрх жагсаалтад таны байр байхгүй бол сүлжээ ороогүй гэсэн үг юм. Та сүлжээ оруулах хүсэлтээ бидэнд илгээнэ үү.',
  'home.development': 'Тогтвортой хөгжил',
  'home.help': 'Тусламж',
  'home.join': 'Бидэнтэй нэгдэх',
  'home.special': 'Онцгой саналууд',
  'home.top': 'Нүүр',
  'homeNav.apps': 'Аппууд',
  'homeNav.offers': 'Саналууд',
  'homeNav.shop': 'Онлайн дэлгүүр',
  hour: 'цаг',
  infoLanguage: 'Мэдээлэл авах хэл',
  infoType: 'Мэдээлэл авах хэлбэр',
  loading: 'Түр хүлээнэ үү',
  location: 'Байршил',
  networkCoverageType: 'Сүлжээний хамрах хүрээ',
  NetworkCoverageRegion: 'NetworkCoverageRegion',
  networktype: 'Сүлжээний төрөл',
  login: 'Нэвтрэх',
  management: 'Удирдлагын баг',
  'menu.5g': '5G сүлжээ',
  'menu.advice': 'Зөвлөмж',
  'menu.news': 'Мэдээлэл',
  'menu.promo': 'Урамшуулал',
  'menu.registration': 'Бүртгэл',
  'menu.notice': 'Мэдэгдэл',
  'menu.service': 'Үйлчилгээ',
  'menu.shop': 'Дэлгүүр',
  'menu.hitone': 'HiTone',
  million: 'сая',
  minute: 'минут',
  mobicom: 'МОБИКОМ КОРПОРАЦИ',
  month: 'сар',
  mongolian: 'Монгол',
  news: 'Мэдээ',
  'news.all': 'Бүх мэдээлэл',
  'news.new': 'Шинэ',
  'news.read': 'Унших',
  'numberInput.hbb': 'Гэрээний дугаар эсвэл нэвтрэх нэр',
  'numberInput.voo': 'Voo дугаар эсвэл гэрээний дугаар',
  'number.choose': 'Дугаар сонгох',
  'number.chosen': 'Сонгосон дугаар',
  'number.deviceList': 'Төхөөрөмжийн жагсаалт',
  'number.search': 'Дугаар хайх',
  'number.available': 'Боломжит дугаар',
  'number.sim': 'СИМ карт холбох',
  'number.sim.guide':
    'СИМ картны ард байрлах F үсэгнээс өмнөх 9 оронтой тоог оруулан картаа холбоорой',
  'number.success.title': 'Старсын дугаар амжилттай үүслээ',
  'number.success.body': 'Мобикомыг сонгосон танд баярлалаа',
  'number.save': 'Та доорх дугаарыг хадгалсан байна. Энэ дугаараа авах уу?',
  'number.buyOther': 'Өөр дугаар авья',
  'number.save.title': '12 цаг',
  'number.save.description':
    'Та сонгосон дугаараа 12 цагийн дотор БЭЛЭН СИМ карт дээр үүсгэж авна уу. БЭЛЭН СИМ картыг өөрт ойрхон Мобикомын гэрээт борлуулагч болон CU сүлжээ дэлгүүрээс авах боломжтой.',
  'number.verifyInfo': 'Мэдээллээ баталгаажуулах',
  'number.deposit': 'Барьцаа',
  'number.registrationFee': 'Бүртгэлийн хураамж',
  'number.simFee': 'Симний хураамж',
  'number.terms': 'Гэрээ болон үйлчилгээний нөхцөлүүдтэй танилцаж зөвшөөрсөн',
  'number.step1Title': 'Мэдээллээ оруулах',
  'number.step1Desc': 'Хувийн мэдээллээ оруулах',
  'number.step2Title': 'Бүртгэлээ оруулах',
  'number.step2Desc': 'Мэдээллээ баталгаажуулах',
  'number.step3Title': 'Гэрээ хийх',
  no: 'Үгүй',
  noResult: 'Хайлтын үр дүн олдсонгүй',
  notMandatory: 'Заавал биш',
  order: 'Захиалах',
  'order.create.save.number': 'Захиалга хийх утасны дугаараа оруулна уу.',
  'order.confirmed': 'Захиалга баталгаажсан',
  'order.date': 'Захиалга хийсэн огноо',
  'order.delivery.address': 'Дэлгэрэнгүй хаяг',
  'order.delivery.addressInfo': 'Хаягийн дэлгэрэнгүй мэдээлэл',
  'order.delivery.afternoon': '14:00-20:00',
  'order.delivery.city': 'Аймаг/Хот',
  'order.delivery.delivery': 'Хүргэлт',
  'order.delivery.district': 'Сум/Дүүрэг',
  'order.delivery.division': 'Баг/Хороо',
  'order.delivery.fee': 'Хүргэлтийн үнэ',
  'order.delivery.firstName': 'Нэр',
  'order.delivery.firstName.error': 'Нэр оруулна уу!',
  'order.delivery.get': 'Хүргэлтээр авах',
  'order.delivery.lastName': 'Овог',
  'order.delivery.lastName.error': 'Овог оруулна уу!',
  'order.delivery.morning': '10:00-14:00',
  'order.delivery.onWay': 'Хүргэлтэд гарсан',
  'order.delivery.pickup': 'Очиж авах',
  'order.delivery.registerNo.error': 'Регистрийн дугаар оруулна уу!',
  'order.delivery.start': 'Хүргэлтэд гарах',
  'order.delivery.success': 'Амжилттай хүргэгдсэн',
  'order.delivery.time': 'Захиалга хүлээн авах цагаа сонгоно уу.',
  'order.delivery.title': 'Хүргэлтийн мэдээлэл',
  'order.empty': 'Захиалга байхгүй байна',
  'order.history': 'Түүх',
  'order.information.orderInfo': 'Захиалгын мэдээлэл',
  'order.information.user': 'Захиалагч',
  'order.information.userInfo': 'Хэрэглэгчийн мэдээлэл',
  'order.items': 'Бараанууд',
  'order.my': 'Миний захиалга',
  'order.notif':
    'Түр хүлээнэ үү. Таны захиалсан бүтээгдэхүүнүүдийг шалгаж байна',
  'order.paymentInfo': 'Төлбөрийн мэдээлэл',
  'order.receive.form': 'Бүтээгдэхүүнийг хүлээж авах хэлбэр',
  'order.receive.place': 'Очиж авах газар',
  'order.receive.time': 'Бүтээгдэхүүнийг авах цаг',
  'order.status': 'Хүргэлтийн төлөв',
  'order.summary': 'Захиалгын хураангуй',
  'order.totalAmount': 'Нийт үнийн дүн',
  'order.vat': 'НӨАТ',
  'orderSummary.selectedNumberLabel': 'Сонгосон багц',
  'orderSummary.noMainService': 'Үндсэн үйлчилгээ сонгогдоогүй байна',
  'orderSummary.additionalServices': 'Нэмэлт эрхүүд',
  'orderSummary.usageLimitTitle': 'Хэрэглээ хязгаарлах түвшин',
  'orderSummary.usageLimitDescription': 'Таны хэрэглээ хэт өсөхөөс сэргийлэх авто хязгаарлалт',
  'orderSummary.usageLimitActiveLabel': 'Хэрэглээ хязгаарлах түвшин:',
  'orderSummary.detailsButton': 'Дэлгэрэнгүй мэдээлэл',
  'orderSummary.usageLimitBody':
    'Дараа төлбөрт үйлчилгээний Миний Моби багцтай хэрэглэгчдийн дугаарын хэрэглээг үе шаттайгаар мэдээлэх, хэрэглээ хязгаарлах түвшинд хүрсэн тохиолдолд мэдээлэл хүргээд гарах хэрэглээг хязгаарлах үйлчилгээ юм.',
  'orderSummary.activationMandatoryTitle': 'Заавал идэвхижүүлэх нөхцөл',
  'orderSummary.activationMandatoryBody':
    'Дараа төлбөрт үйлчилгээний Миний Моби багцын шинэ хэрэглэгч эсвэл урьдчилсан болон хосолсон төлбөрт багцаас дараа төлбөрт Миний Моби багц руу шилжиж буй хэрэглэгчдэд 6 сарын хугацаатай хэрэглээ хязгаарлах түвшинг тогтоох ба хугацаа дуусахад системээс автоматаар цуцлагдана.',
  'orderSummary.usageLimitReminderTitle': 'Заавал идэвхижүүлэх нөхцөл',
  'orderSummary.usageLimitReminderBody':
    'Хэрэглэгчийн багцын суурь хураамж болон тухайн сарын хэрэглээ нь Хэрэглээ Хязгаарлах Түвшний 80%-д хүрэхэд сануулах мессэж системээс очих ба хэрэглээ нь 100%-тай тэнцэх үед хэрэглэгчийн гарах хэрэглээ хязгаарлагдана.',
  'orderSummary.closeButton': 'Хаах',
  'orderSummary.perMonthLabel': 'Сард',
  'orderSummary.selectedPackageName': 'Сонгосон багц',
  'orderSummary.customPackageName': 'Сонгосон багц',
  'orderSummary.smsService': 'Мессеж үйлчилгээ',
  'orderSummary.videoStreamingService': 'Видео стриминг',
  'orderSummary.entertainmentService': 'Энтертайнмент үйлчилгээ',
  'openApp.title': 'Хүссэн үйлчилгээгээ Моби апп-аас хурдан шуурхай аваарай',
  'openApp.open': 'Нээх',
  'openApp.download': 'Татах',
  others: 'Бусад',
  our: 'Бидний',
  call: 'Яриа',
  package: 'Багц',
  'package.choose': 'Багц сонгох',
  'package.viewDetails': 'Дэлгэрэнгүй харах',
  'package.addOnPackage': 'Нэмэлт багц',
  'package.usageLimitLevel':
    'Уг дараа төлбөрт дугаар нь хэрэглээ хязгаарлах түвшингүй /ХХТ/ үүсч байгаа тул та хэрэглээгээ хянаарай.',
  'package.addOnPackageDescription':
    'Та доорх багцуудаас нэмэлтээр авах боломжтой',
  packageselection: 'Та багцаа сонгоно уу',
  packageshift: 'Багц солих',
  'packageshift.currentPackage': 'Одоогийн багц',
  'packageshift.chooseService': 'Үйлчилгээ сонгох',
  'packageshift.chooseCard': 'Шилжих боломжит багцаа сонгох',
  'packageshift.possiblePackages': 'Шилжих боломжит багцууд',
  'packageshift.packageType': 'Багцын төрөл',
  'packageshift.packageTypeDescription':
    'Та өөрийн хэрэглээнд тохирох багцын төрлийг сонгоорой',
  'packageshift.info1': 'Та сард 1 удаа дугаарын багцаа солих боломжтой.',
  'packageshift.info2':
    'Таны сонгосон багцын төлбөр ашигласан хоногт дүйцүүлэн бодогдоно.',
  'packageshift.info3':
    'Хэрэв таны дугаар хугацаатай багцын гэрээтэй бол гэрээний хугацаанд дугаарын багцаа ахиулах боломжтой. Харин эргэн буурах боломжгүйг анхаарна уу.',
  'packageshift.cation1':
    'Таны хуучин болон шинэ сонгосон багцын төлбөр ашигласан хоногт тань дүйцүүлэн бодогдоно.',
  'packageshift.cation2':
    'Хэрэв та гар утас эсвэл дагалдах хэрэгслийн зээлтэй бол анх гэрээ байгуулсан багцаас доош багц сонгох боломжгүйг анхаарна уу.',
  'packageshift.cation3':
    'Хэрэв таны дугаар хугацаатай багцын гэрээтэй бол гэрээний хугацаанд дугаарын багцаа ахиулах боломжтой. Харин эргэн буурах боломжгүйг анхаарна уу.',
  'packageshift.cation4': 'Та сард 1 удаа дугаарын багцаа солих боломжтой.',
  'packageshift.cation5':
    'Таны сонгосон багцын төлбөр ашигласан хоногт дүйцүүлэн бодогдоно',
  'packageshift.onlyOnce':
    'Уучлаарай, та сард зөвхөн 1 удаа багцаа солих боломжтой.',
  'packageshift.numbersaved':
    'Уучлаарай, таны дугаар хадгалагдсан төлөвтэй байгаа тул багцаа солих боломжгүй байна.',
  'packageshift.bill_remain':
    'Уучлаарай, та төлбөрийн үлдэгдэлтэй байгаа тул багцаа солих боломжгүй байна.',
  'packageshift.unavailable':
    'Уучлаарай, та одоогоор багцаа солих боломжгүй байна. Та 2222 лавлах төвд холбогдон эсвэл үйлчилгээний салбарт хандан мэдээллээ шалгуулна уу.',
  'packageshift.vipCustomer':
    'Уучлаарай, та мобиком апликейшнаар багцаа солих боломжгүй байгаа тул 2222 лавлах төвд эсвэл үйлчилгээний салбарт хандана уу.',
  'packageshift.credit_limit':
    'Энэ багц руу шилжсэнээр таны хэрэглээ хязгаарлах нэмэлт нөхцөл $limit болж өөрчлөгдөхийг анхаарна уу',
  'packageshift.choosen_info': 'Таны сонгосон багцын мэдээлэл',
  'packageshift.select_package': 'Сонгосон багц',
  'packageshift.no_packages':
    'Уучлаарай, танд шилжих боломжтой багц байхгүй байна.',
  'packageshift.no_mail_info':
    'Та өөрийн бүртгэлтэй и-мэйл хаягаа профайл цэсээс шинэчлэх боломжтой.',
  'packageshift.success':
    'Таны хүсэлтийн мэдээллийг $email бүртгэлтэй хаяг руу илгээлээ.',
  'packageshift.signature': 'Та гарын үсгээ зурна уу',
  'payment.failed': 'Төлбөр амжилтгүй.',
  'payment.success': 'Төлбөр амжилттай төлөгдлөө!',
  'payment.pending': 'Төлбөр төлөлт хүлээгдэж байна!',
  'payment.thank': 'Мобикомыг сонгосон танд баярлалаа.',
  'payment.amount': 'Төлсөн дүн',
  'payment.vat_email': 'НӨАТ ийн баримтыг таны @ цахим шуудан руу илгээлээ.',
  'payment.items': 'Таны захиалсан бараа',
  phoneNumber: 'Утасны дугаар',
  contractNumber: 'Гэрээний дугаар',
  phoneNumberAndContract: 'Утасны дугаар эсвэл гэрээний дугаар',
  vooNumber: 'VOO дугаар',
  mobinetNumber: 'Нэвтрэх нэр',
  'phoneNumber.verification': 'Утасны дугаараар баталгаажуулах',
  'service.select': 'Үйлчилгээний төрөл',
  'phoneNumber.insert': 'Дугаараа оруулах',
  price: 'Үнэ',
  product: 'Бараа',
  payment: 'Төлбөр',
  paymentAmount: 'Төлбөрийн дүн',
  preorderP1: 'Бэлнээр',
  preorderP2: 'Зээлээр',
  preorderQ1: 'Та худалдан авах гар утасныхаа загварыг сонгоно уу',
  preorderQ2: 'Та худалдан авах гар утасныхаа өнгийг сонгоно уу',
  preorderQ3: 'Та төлбөр төлөх төрлөө сонгоно уу',
  preorderQ4: 'Та худалдан авсан гар утсаа очиж авах салбарыг сонгоно уу',
  preorderQ5: 'Та эргэн холбоо барих дугаараа болон овог нэрээ оруулна уу',
  productPrice: 'Бүтээгдэхүүний үнэ',
  quickaction: 'Хялбар үйлчилгээ',
  'quick.buyData': 'Дата авах',
  'quick.buyMnp75': 'MNP75 нэгж',
  'quick.buyUnit': 'Нэгж авах',
  'quick.buyWifiCard': 'Wifi карт авах',
  'quick.homeInternet': 'Өрхийн интернэт',
  'quick.myInternet': 'Манай интернэт',
  'quick.mobihome': 'Mobihome',
  'quick.newNumber': 'Шинэ дугаар',
  'quick.payBill': 'Төлбөр төлөх',
  'quick.simRecover': 'Сим сэргээх',
  'quick.wifiCard': 'Wifi карт',
  'quick.wifiDevice': 'Wifi төхөөрөмж',
  registerNo: 'Регистрийн дугаар',
  relation: 'Таны хэн болох',
  required: 'Заавал',
  'sdg.title': 'Мобиком групп тогтвортой хөгжлийн төлөө',
  'sdg.highlighted': 'Онцлох төслүүд',
  'sdg.others': 'Бусад төслүүд',
  search: 'Хайх',
  second: 'секунд',
  seeLocation: 'Байршил харах',
  'service.additional': 'Нэмэлт үйлчилгээ',
  'service.general': 'Үндсэн үйлчилгээ',
  'service.internet': 'Интернэт үйлчилгээ',
  'service.mobile': 'Мобайл үйлчилгээ',
  'service.serviceButton': 'Үйлчилгээ авах',
  share: 'Бусадтай хуваалцах',
  shop: 'Онлайн дэлгүүр',
  'shop.accessories': 'Дагалдах хэрэгсэл',
  'shop.addToCart': 'Сагсанд нэмэх',
  'shop.addedToCart': 'Сагсанд нэмэгдлээ',
  'shop.address': 'Хаяг',
  'shop.backToShop': 'Дэлгүүр рүү буцах',
  'shop.brand': 'Брэнд',
  'shop.buyLeasing': 'Зээлээр авах',
  'shop.cart': 'Сагс',
  'shop.comparison': 'Харьцуулах',
  'shop.deliveryinfo.title':
    'Захиалсан бараа бүтээгдэхүүнээ Улаанбаатар хотын хаана ч хүргүүлэх боломжтой',
  'shop.deliveryinfo.text':
    'Таны бараа хүргэх байршлаас хамааран ажлын 1-2 хоногт хүргэгдэнэ.',
  'shop.emptyCart': 'Таны сагс хоосон байна',
  'shop.filter': 'Шүүлтүүр',
  'shop.finish': 'Дуусгах',
  'shop.gift': 'Бэлгэнд',
  'shop.goToCart': 'Сагсаа харах',
  'shop.hasGift': 'Бэлэгтэй',
  'shop.hasSale': 'Хямдралтай',
  'shop.internet': 'Интернэт төхөөрөмж',
  'shop.introduction': 'Дэлгэрэнгүй',
  'shop.leasePeriod': 'Зээлийн хугацаа',
  'shop.leaseAdvance': 'Урьдчилгаа төлбөр',
  'shop.leaseMonthlyPayment': 'Сарын төлбөр',
  'shop.leasing1':
    'Та зээлийн нөхцөлөөр гар утас авахаар төлөвлөж байвал зээлийн шалгуур хангаж байх ёстой. Доорх зааврын дагуу зээлийн шалгуураа шалгаарай',
  'shop.leasing1.5': '“i” үсгийг “366” дугаар руу мессежээр явуулаарай',
  'shop.leasing2':
    'Та гар утсаа зээлээр авахыг хүсвэл өөрт ойр салбараас болон mobicom.mn веб сайтаар авах боломжтой',
  'shop.leasingCondition': 'Зээлийн нөхцөл',
  'shop.leasingRequirement': 'Зээлээр олгох багц',
  'shop.seeAll': 'Бүгдийг харах',
  'shop.smartDevice': 'Ухаалаг хэрэгсэл',
  'shop.specification': 'Үзүүлэлт',
  'shop.title': 'Дэлгүүр',
  'shop.corpEmail': 'Гүйлгээний мэдээлэл авах имэйл хаяг',
  'shop.vat': 'НӨАТ-ын баримт',
  'shop.vatCons': 'Хувь хүн',
  'shop.vatCorp': 'Байгууллага',
  'shop.vatCorpId': 'Байгууллагын регистр',
  'shop.vatEmail': 'НӨАТ-ын баримт авах имэйл хаяг',
  'shop.vatEmailError': 'НӨАТ-ын баримт авах имэйл хаягийн формат буруу байна',
  'sim.choose': 'Сим сонгох',
  'sim.choosen': 'Сонгосон Сим',
  'sim.connect': 'Сим картаа холбох',
  'sim.esim.guide':
    'Таны утас eSIM дэмждэг эсэхийг дээрх загваруудаас давхар шалгах боломжтой.',
  'sim.esim.warning':
    'QR кодоор үүсгэж аван ухаалаг утасны камераар болон зурган хэлбэрээр хадгалсан файл-р идэвхжүүлнэ.',
  'sim.verification': 'Сим баталгаажуулах',
  'sim.qrsent': 'eSim-ийг баримтыг таны $email цахим шуудан руу илгээлээ',
  'sim.select_device': 'Төхөөрөмжөө сонгох',
  'sim.selectType': 'Сим картны төрөл сонгох',
  'sim.self': 'Бэлэн сим',
  'sim.self.guide':
    'Та SIM картны ард байрлах F үсгийн өмнөх 9 цифрийг оруулснаар өөрийн биет SIM-ээ идэвхжүүлэх боломжтой.',
  'sim.self.warning': 'Сим картны дугаарыг оруулан суулгана',
  'sim.tan.getagain': 'Дахин код авах ',
  'sim.tan_locked': 'ТАН код 3 удаа буруу оруулсан байна. Дахин код авна уу.',
  'sim.tan_creation_locked': 'ТАН код түгжигдлээ. Та $ дараа дахин хандана уу.',
  'sim.tan_mismatch': 'ТАН код буруу байна.',
  'sim.tan_sent': 'Баталгаажуулах кодыг таны $email хаягруу илгээлээ',
  'sim.tan_sent_phone':
    'Баталгаажуулах кодыг таны $phoneNumber дугаар руу илгээлээ',
  'sim.warning': 'Та дугаараа сэргээж авах сим картны төрлөө сонгоно уу?',
  simple: 'Энгийнийг ухаалгаар',
  soon: 'Тун удахгүй',
  sort: 'Эрэмбэ',
  success: 'Амжилттай',
  stars: 'Старс багц',
  'stars.child_info': 'Хүүхдийн мэдээлэл',
  'stars.child_register': 'Хүүхдийн регистрийн дугаар',
  'stars.child_email': 'И-мэйл хаяг/заавал биш/',
  'stars.contact': 'Холбоо барих хүний дугаар',
  'stars.relation': 'Хүүхэдтэй ямар холбоотой вэ',
  'stars.terms':
    'Та ЭНД дарж үйлчилгээний нөхцөлтэй танилцана уу. Та ҮРГЭЛЖЛҮҮЛЭХ товчийг дарснаар үйлчилгээний нөхцөлийг хүлээн зөвшөөрсөнд тооцно.',
  'stars.feature.guardianUnlimited':
    'Асран хамгаалагч/ Гэр бүлийнхэнтэйгээ хязгааргүй ярих',
  'stars.feature.friendsFree': 'STARS-н найзуудтайгаа үнэгүй ярих',
  'stars.feature.serviceDaysUnlimited': 'Үйлчилгээний хоног хязгааргүй',
  'stars.feature.locationTracking': 'Байршил харах',
  'stars.feature.balanceAlert': 'Утасны цэнэг мэдээлэх',
  term1:
    'Энэхүү нөхцөл нь хэрэглэгч онлайн салбараар үйлчлүүлэх, худалдан авалт хийхээсээ өмнө уншиж танилцан, хүлээн зөвшөөрсний үндсэн дээр хэрэгжинэ',
  term2:
    'Энэхүү үйлчилгээний нөхцөлийн хэрэгжилтэд Мобиком Корпораци /цаашид байгууллага гэх/ болон хэрэглэгч хамтран хяналт тавина',
  termMain:
    'Мобиком Корпорацийн албан ёсны онлайн салбарт тавтай морил. Уг үйлчилгээний нөхцөл нь онлайн салбараар үйлчлүүлэх, худалдан авалт хийхтэй холбоотой үүсэх харилцааг зохицуулна',
  termsOfService: 'Үйлчилгээний нөхцөл',
  thankyoutext: 'Мобикомыг сонгосон танд баярлалаа',
  timeTable: 'Цагийн хуваарь',
  total: 'Нийт',
  totalPrice: 'Нийт үнэ',
  'trade-in.chooseDevice': 'Та утсаа сонгоно уу',
  'trade-in.condition': 'Trade In нөхцөл',
  'trade-in.desc':
    'Trade In гэдэг нь: Та Apple брэндийн хуучин утсаа үнэлүүлэн өгч, шинэ загварын утаснаас тухайн үнийн дүнгээ хасуулж авах худалдан авалтын төрөл юм.',
  'trade-in.question': 'Trade In нөхцөлөөр авах уу',
  type: 'Төрөл',
  unit: 'Нэгж',
  'user.authentication': 'Бүртгэл баталгаажуулах',
  'user.confirmInfo': 'Та өөрийн хувийн мэдээллээ баталгаажуулна уу',
  'unit.warning':
    'Нэгж авах утасны дугаараа оруулснаар тухайн дугаарыг цэнэглэх боломжтой нэгжийн картууд харагдана',
  'user_info.confirm': 'Мэдээллээ баталгаажуулах',
  'user_info.your_info': 'Таны мэдээлэл',
  'user_info.nationality': 'Иргэншил',
  'user_info.surname': 'Овог',
  'user_info.name': 'Нэр',
  'user_info.register_no': 'Регистрийн дугаар',
  'user_info.gender': 'Хүйс',
  'user_info.date_of_birth': 'Төрсөн он, сар, өдөр',
  'vat.options': 'Хувь хүн, байгууллага',
  'vision.mission': 'Эрхэм зорилго',
  'vision.missiontext':
    'Бид, Мобиком групп нь хамт олон, тэдний гэр бүлийн сайн сайхан болон оюунлаг сэтгэлгээний хөгжил дэвшлийг дэмжиж, хэрэглэгчид, түншүүдтэйгээ сэтгэлд хоногшсон дурсамжуудыг хамтдаа бүтээж, бизнесийн шинэлэг арга барилаар итгэл дүүрэн, тэгш нийгмийг цогцлоох үйлсийг манлайлна.',
  'vision.value': 'Үнэт зүйлс',
  'vision.valuetext':
    'Бид шударга, ёс зүйтэй байна \nБид бусдыг ойлгож, хүндэлнэ \nБид шинийг эрэлхийлэгч байна \nБид өөрчлөлтийг эерэгээр хүлээн авч, хэрэгжүүлнэ',
  'vision.vision': 'Алсын хараа',
  'vision.visiontext':
    'Бид тасралтгүй шинэчлэлээр хамтын үнэ цэнийг бүтээж, хүн бүрийн итгэлт хамтрагч байх болно.',
  yes: 'Тийм',
  yourcart: 'Таны сагсанд',
  'appPrompt.desc':
    'Мобикомын бүтээгдэхүүн үйлчилгээг гар утаснаасаа хамгийн хурдан авах боломжийг олгож байна.',
  'appPrompt.open': 'Апп нээх',
  'appPrompt.stay': 'Үлдэх',
  'digitalContent.terms': 'Цахимаар үйлчилгээ үзүүлэх нөхцөл',
  'digitalContent.term1':
    '1. Энэхүү нөхцөлөөр хэрэглэгч Мобиком групп компанийн үйлчилгээг цахим сувгууд (мобиком апликейшн болон mobicom.mn веб)-р дамжуулан авахтай холбогдох харилцааг зохицуулна.',
  'digitalContent.term2':
    '2. Хэрэглэгч нь Мобиком групп компанийн цахим сувгуудаар дамжуулан үйлчилгээ авахын тулд өөрийн албан ёсны и-мэйл хаягийг бүртгүүлэн энэхүү нөхцөлийг бүрэн уншиж танилцан, зөвшөөрсөн байна".',
  'digitalContent.term3':
    '3. Хэрэглэгч энэ нөхцөлийг зөвшөөрснөөр цаашид цахим сувгаар дамжуулан үйлчилгээ авахдаа нууц үг, өөрийн нэр дээр бүртгэлтэй утасны дугаар эсхүл баталгаажсан и-мэйл хаягт очих нэг удаагийн нууц үг, цахим гарын үсэг, тоон гарын үсгийг ашиглан цахимаар үйлчилгээ авахыг зөвшөөрч байгаа болно.',
  'digitalContent.term4':
    '4. Энэхүү нөхцөлийн 3 дахь хэсэгт заасан арга хэрэгслүүдийг ашиглан авсан үйлчилгээ, хийсэн хэлцэл, гэрээ нь хүчин төгөлдөр болохыг талууд харилцан хүлээн зөвшөөрч байгаа болно.',
  'digitalContent.term5':
    '5. Хэрэглэгч нь өөрийн нэр дээр бүртгэлтэй утасны дугаар болон бүртгүүлсэн и-мэйл хаягаа бусдад ашиглуулахгүй, дамжуулахгүй бөгөөд өөрт хамаарах мэдээллийн нууцлалаа хадгалах, хамгаалах үүрэгтэй. Хэрэглэгч нь энэхүү үүргээ биелүүлээгүйгээс өөрт учрах аливаа эрсдэлийг бүрэн хариуцна.',
  'digitalContent.term6':
    '6. Мобиком групп компаниуд нь цахим сувгуудаар дамжуулан хэрэглэгчид хүргэх бүтээгдэхүүн, үйлчилгээний талаарх мэдээллийн үнэн бодит байдал болон цахим сувгуудынхаа мэдээллийн аюулгүй байдлыг хариуцна.',
  'digitalContent.term7':
    'Энэхүү нөхцөлд дурдсанаас бусад асуудлыг Үйлчилгээний гэрээ болон бусад үйлчилгээний нөхцөлд зааснаар зохицуулна.',
  logoElement: 'Логоны элемент',
  logoSpace: 'Логоны зай',
  logoText: 'Текст',
  logoColor: 'Логоны өнгө',
  logoDownload: 'Лого татах',
  guideDownload: 'Заавар татах',
  logoColorDesc:
    'Энэхүү өнгө нь Мобиком брэндийг танигдалт, дүр төрхийг илэрхийлэх чухал үзүүлэлт бөгөөд бизнесийн мөн чанар, бидний хэв маягийг шингээсэн нэрийн хуудас юм.',
  logoTextDesc: 'Компанийн нэрийг дараах байдлаар бичнэ.',
  logoSpaceDesc:
    'Мобикомын логог тод, ялгаралтай харуулахын тулд эргэн тойронд тодорхой зай үлдээнэ. Логог байршуулахдаа тусгаарлалтын энэхүү зайг аль болох их гаргаарай. ',
  logoElementDesc:
    'Энэхүү лого нь Мобикомыг байгууллага, бизнес, группийн хувиар тодорхойлж буй илэрхийлэмж, тэмдэг билээ.',
  logoTitle: 'Мобикомын лого ашиглах зааварчилгаа',
  logoDesc:
    'Энэхүү лого нь Мобиком брэндийг илэрхийлэх гол элемент билээ. Брэндийг тууштай, үнэн зөвөөр  илэрхийлэн таниулахын тулд бид лого ашиглах зааварчилгааг хүргэж байна. Энэхүү зааварчилгаа нь логог бүх платформ, материал дээр зохистой, зөв ашиглахад зориулагдсан болно. ',
  copy: 'Хуулагдлаа',
  logoWarning: 'Логог ашиглахдаа дараах зүйлийг анхаараарай.',
  logowarningDesc1: 'Логоны үндсэн хэмжээ, харьцааг өөрчлөхгүй байх',
  logowarningDesc2: 'Логоны өнгийг өөрчлөхгүй байх',
  logowarningDesc3: 'Эффект нэмэхгүй байх',
  logowarningDesc4: 'Логоны дүрсийг өөрчлөх, эргүүлэхгүй байх.',
  logowarningDesc5:
    'Эдгээр зааварчилгааг дагаснаар Мобиком брэндийн нэр хүнд,  имижийг хүчтэй, тууштай хэвээр хадгалахад тусалж буй юм.  Хамтран ажилласанд баярлалаа!',
  logowarningTitle: ' Логог ашиглахдаа дараах зүйлийг анхаараарай',
  logoBack: 'Мобиком лого арын дэвсгэр',
  logoDontUse: 'Логоны зохисгүй хэрэглээ',
  logoDontuseDesc1: 'Уусгалтгүй ашиглах',
  logoDontuseDesc2: 'Уусгалтыг дур мэдэж замбараагүй тавих',
  logoDontuseDesc3: 'Брэнд логоны бичиглэлийг өөрчлөх',
  logoDontuseDesc4: 'Брэнд логоны харьцаа эвдэх',
  logoDontuseDesc5: 'Лого сүүдэртэй ашиглах',
  logoDontuseDesc6: 'Логоны өнгийг өөрчлөх',
  logoDontuseDesc7: 'Бараан дэвсгэр дээр буруу логоны хувилбар ашиглах',
  logoDontuseDesc8: 'Тод дэвсгэр дээр буруу логоны хувилбар ашиглах',
  logoDontuseDesc9:
    'Брэндийн үндсэн улаан өнгөнөөс өөр өнгийн дэвсгэр дээр цагаан лого ашиглах',
  roamingCountry: 'Улс',
  roamingRegion: 'Бүсчлэл',
  roamingDomesticCall: 'Улс дотроо',
  roamingToMongolia: 'Монгол улс руу',
  roamingOtherCounties: 'Бусад улс руу',
  roamingIncomingCalls: 'Дуудлага хүлээж авах',
  roamingOffnetMessage: 'Гарах мессеж',
  roamingVolume: 'Хэмжээ',
  roamingDuration: 'Хугацаа',
  roamingSpeed: 'Хурд',
  roamingTariff: 'Үнэ',
  roamingType: 'Багцын төрөл',
  roamingDataPackage: 'Дата багц',
  roamingSms: 'Мессеж багц',
  roamingDesc:
    'Дэлхийн хаа нэгтээ Монгол Улсаас бусад улс орны сүлжээнд аялах үедээ өөрийн дугаар бүхий гар утсаа ашиглах боломжийг олгодог үйлчилгээ юм.',
  roamingService: 'Роуминг үйлчилгээ',
  roamingSearch: 'Хайх',
  roamingEmbassy: 'Элчин сайдын яамны мэдээллийг авахыг хүсвэл энд дарна уу',
  phoneNumbers: 'Үүрэн телефон',
  referralPromoCode: 'Урилгын код',
  referralCodeActivate: 'Идэвхжүүлэх',
  referralCodeNotValid: 'Урилгын код олдсонгүй',
  cooperationCompany: 'Компани',
  cooperationCitizen: 'Хувь хүн',
  'sort.priceAsc': 'Үнэ өсөхөөр',
  'sort.priceDesc': 'Үнэ буурахаар',
  'sort.result': 'илэрц байна',
  'shop.maximum': 'Ихдээ',
  'shop.minimum': 'Багадаа',
  'sort.default': 'Эрэмбэ',
  'shop.location': 'Та өөрт ойр салбараас зээлээр худалдан аваарай.',
  'shop.state': 'Төлөв',
  'shop.leasing2.5':
    'Хэрэв та зээлээр худалдан авсан тохиолдолд төхөөрөмжийн үнэ үндсэн үнээр бодогдоно.',
  'quick.leasing': 'Зээлийн тооцоолуур',
  'leasing.step1Title': 'Баталгаажуулалт',
  'leasing.step1Desc': 'Бүртгэл хийх',
  'leasing.step2Title': 'e-Mongolia',
  'leasing.step2Desc': 'Баталгаажуулах, мэдээлэл татах',
  'leasing.step3Title': 'Зээлийн мэдээллийн лавлагаа',
  'leasing.step3Desc': 'Баталгаажуулах, мэдээлэл татах',
  'leasing.step1TextTitle': 'Мобикомын хэрэглэгч',
  'leasing.step1TextDesc': 'Мобикомын дугаартай хэрэглэгч',
  'leasing.step1TextTitle2': 'Шинэ хэрэглэгч',
  'leasing.step1TextDesc2': 'Бусад операторын дугаартай хэрэглэгч',
  'leasing.eMongoliaconfirm': 'E-Mongolia баталгаажуулалт',
  'leasing.eMongoliaText':
    'Бид таныг танин баталгаажуулахын тулд \ne-mongolia системрүү нэвтрэх гэж байна',
  'leasing.tan_sent': 'Баталгаажуулах кодыг таны \n$email хаягруу илгээлээ',
  'leasing.sent_phone':
    'Баталгаажуулах кодыг таны \n$phoneNumber дугаар руу илгээлээ',
  'leasing.vat': 'Нэхэмжлэлийн хураангуй',
  'leasing.warning':
    'Зээлийн эрхийн дүн таны и-мэйл рүү илгээгдэх тул и-мэйл хаяг зөрүүтэй байвал мобиком аппликэйшн-д хандан шинэчлээрэй.',
  quickaction1: 'Интернэт үйлчилгээ',
  'leasing.reference': 'Зээлийн мэдээллийн лавлагаа',
  'leasing.referenceDet':
    'Зээлийн мэдээллийн сангийн лавлагаа \nавахыг зөвшөөрч байна уу?',
  'leasing.blacklist.title': 'Мэдэгдэл',
  'leasing.blacklist.description':
    'Та энэ үйлчилгээг авах боломжгүй байна. \n2222-т хандана уу.',
  'leasing.underage.title': 'Мэдэгдэл',
  'leasing.underage.description':
    'Уучлаарай, та 18 нас хүрээгүй тул энэ \nүйлчилгээг ашиглах боломжгүй байна.',
  'leasing.dan_url_missing': 'Дан холбоос алга байна',
  'leasing.fail': 'Ойлголоо',
  'leasing.info': '',
  'leasing.info.benefit': 'Хүүгүй. Баталгаатай. Сонголттой',
  'leasing.info.benefit1':
    'Та хүссэн гар утсаа хүүгүй, урьдчилгаа төлбөргүй уян хатан \nнөхцөлөөр лизингээр авах боломжтой боллоо!',
  'leasing.info.benefit_terms': 'Лизингийн нөхцөлүүд:',
  'leasing.info.benefit_terms1': 'Лизингийн хугацаа: 6, 12, 24 сар',
  'leasing.info.benefit_terms2':
    'Урьдчилгаа төлбөрийн хувилбарууд: 0%, 10%, 35%',
  'leasing.info.termsofservice': 'Үйлчилгээний нөхцөл',
  'leasing.info.termsofservice1':
    '18-c дээш насны хэрэглэгч энэхүү үйлчилгээг авах боломжтой.',
  'leasing.info.termsofservice2':
    'Зээлийн эрх тооцоолох үйлчилгээ нь 2’000₮ /НӨАТ багтсан/ төлбөртэй бөгөөд 24 цагийн хугацаанд хүчинтэй байна. ',
  'leasing.info.termsofservice3':
    'Тооцоолол хийгдсэн дүн нь зөвхөн сард төлөх боломжит дүнгээр тогтоогдоно.',
  'leasing.info.termsofservice4':
    'Та өөрт ойр байрлах Мобикомын үйлчилгээний салбарт хандан гар утас төхөөрөмжийн зээлийн үйлчилгээг авах боломжтой.',
  'leasing.info.month': 'Сард төлөх дүн',
  'leasing.info.monthPay': 'Сард төлөх дүн',
  'leasing.info.date': 'Хүчинтэй хугацаа',
  'leasing.info.consumer': 'Хувь хэрэглэгч',
  'leasing.info.consumer1':
    'Дараах бичиг баримтаас аль нэгийг авч ирэх шаардлагатай:',
  'leasing.info.consumer2': 'Цахим үнэмлэх',
  'leasing.info.consumer3': 'Цахим үнэмлэхийн лавлагаа',
  'leasing.info.consumer4': 'E-mongolia OTP',
  'leasing.info.consumer5': 'Тоон гарын үсэг',
  'leasing.info.corporate': 'Байгууллагын хэрэглэгч',
  'leasing.info.corporate1': 'Албан бичиг (дараах мэдээллийг багтаасан байх):',
  'leasing.info.corporate2':
    'Албан бичигт гар утас ухаалаг төхөөрөмж зээлээр авах ажилтны овог нэр, регистрийн дугаар, утасны дугаарыг заавал оруулна. Гүйцэтгэх захирал гарын үсэг зурж байгууллагын албан ёсны тамга тэмдгээр баталгаажуулсан байх.',
  'leasing.info.corporate3':
    'Авах төхөөрөмжийн нэр, үнэ, урьдчилгаа төлбөр, зээлийн хугацааг тусгасан байх.',
  'leasing.info.corporate4':
    'Байгууллага төлөөлөн ирэх ажилтны иргэний үнэмлэх түүнийг орлох бичиг баримт:',
  'leasing.info.corporate5': 'Цахим үнэмлэх',
  'leasing.info.corporate6': 'Цахим үнэмлэхийн лавлагаа',
  'leasing.info.corporate7': 'E-mongolia OTP',
  'leasing.info.corporate8': 'Тоон гарын үсэг',
  'leasing.info.location': 'Салбар дээр ирэх',
  'leasing.info.location1':
    'Зээлийн үйлчилгээг авахын тулд хэрэглэгч Мобикомын үйлчилгээний салбарт хандах шаардлагатай.',
  'leasing.confirmzms.title': 'Амжилттай',
  'leasing.confirmzms.description':
    'Та өөрийн зээлийн мэдээллийн лавлагаагаа \nзээлийн мэдээллийн сангаас авна уу.',
  'leasing.step4Title': 'Зээлийн мэдээллийн төлбөр төлөх',
  'leasing.step4Desc': 'Зээлийн эрх тооцоолох',
  'leasing.confirzms.button': 'Зээлийн лавлагаа авах',
  'leasing.successzms.title': 'Зээлийн тооцоолол хийгдэж байна',
  'leasing.successzms.description':
    'Таны зээлийн эрх тогтоогдсоны дараа бүртгэлтэй \nимэйл хаяг руу баталгаажсан мэдээллийг илгээх \nболно. Та түр хүлээнэ үү.',
  'leasing.nomail':
    'Хэрэглэгч таны и-мэйл хаяг бүртгэлгүй байгаа тул \nта и-мэйлээ бүртгүүлнэ үү',
  'leasing.verification_failed.title': 'Мэдэгдэл',
  'leasing.verification_failed.description':
    'Нийгмийн даатгалаас мэдээлэл авахад алдаа гарлаа. \nТа дахин оролдоно уу.',
  'leasing.corpError.title': 'Мэдэгдэл',
  'leasing.corpError.description':
    'Уучлаарай, та энэ үйлчилгээг авах боломжгүй байна. \nТа 2222 болон үйлчилгэний салбарт хандана уу',
  'error.configuratorDataMissing': 'Алдаа гарлаа, дахин оролдоно уу',
  'leasing.confirmzms.web.title': 'Зээлийн мэдээллийн лавлагаа',
  'leasing.confirmzms.web.description':
    'Зээлийн мэдээллийн сангийн лавлагаа \nавахыг зөвшөөрч байна уу?',
  'leasing.confirmzms.button': 'Зөвшөөрөх',
  'leasing.corp.fail':
    'Уучлаарай таны зээлийн эрхийг тогтоох боломжгүй байгаа тул \nта мобиком аппликэйшн эсвэл үйлчилгээний үндсэн салбарт хандана уу.',
  'leasing.register.email':
    'Таны и-мэйл хаяг бүртгэлгүй байна. Зээлийн эрхийн дүн таны \nи-мэйл рүү илгээгдэх тул бүртгэлээ баталгаажуулна уу.',
  'leasing.dan.fail.title': 'Мэдэгдэл',
  'leasing.dan.fail.description':
    'Нийгмийн даатгалаас мэдээлэл авхад алдаа гарлаа. Та дахин оролдоно уу.',
  'leasing.pending.title': 'Зээлийн эрхийг тооцоолж байна',
  'leasing.pending.description':
    'Таны зээлийн эрхийг тооцоолж байх хооронд бусад ажлаа амжуулаад хүлээж байгаарай',
  'leasing.verification_failed.button': 'Дахин оролдох',
  'leasing.complete.text1':
    'Та хүссэн гар утсаа хүүгүй, уян хатан нөхцөлөөр лизингээр авах боломжтой боллоо!',
  'leasing.complete.text2':
    'Та үйлчилгээний нөхцөлөөс хэрхэн зээл авах боломжтой мэдээллийг дэлгэрүүлэн харах боломжтой.',
  'leasing.complete.usedAmount': 'Ашигласан',
  'leasing.complete.Amount': 'Үлдсэн',
  'quick.mnp75': 'MNP75',
  'leasing.register.mismatch.title': 'Мэдэгдэл',
  'leasing.register.mismatch.description':
    'Таны дугаар e-mongolia бүртгэлээс зөрүүтэй \nбайна. Та лавлах 2222 болон үйлчилгээний \nсалбарт хандана уу.',
  'tourist.title': 'Tourist data SIM',
  'tourist.simple': 'Simple through smart',
  'tourist.plans': 'Plans',
  'tourist.plans.subtitle': 'Choose your preferred package',
  'tourist.payment': 'Payment',
  'tourist.choosePackage': 'Choose package plan',
  'tourist.packages': 'Packages',
  'tourist.email': 'E-mail',
  'tourist.email.register': 'E-mail registration',
  'tourist.continue': 'Continue',
  'tourist.simtype': 'Choose SIM type',
  'tourist.selfsim': 'Physical SIM',
  'tourist.selfsim.subtitle':
    'Activate by entering the SIM card number (ICCID) manually.',
  'tourist.selfsim.number': 'SIM card number',
  'tourist.selfsim.desc':
    'You can activate your physical SIM by entering the 9-digit number found before the letter “F” on the back of your SIM',
  'tourist.selfsim.warning':
    'Physical SIM cards are available at Mobicom branches and selected CU and GS25 convenience stores.',
  'tourist.esim': 'eSIM',
  'tourist.esim.desc':
    'Activate using a QR code scanned with your smartphone camera or uploaded as an image.',
  'tourist.esim.phonelist': 'Compatible model list',
  'tourist.esim.choose': 'Choose your device',
  'tourist.esim.info1':
    'To confirm eSIM compatibility please check your device from the provided model list.',
  'tourist.esim.info2': '“Settings -> Cellular -> Add Cellular plan”',
  'tourist.order.summary': 'Order summary',
  'tourist.single.package': 'Package',
  'tourist.price': 'Price',
  'tourist.payment.method': 'Payment method',
  'tourist.credit.card': 'Credit / Debit card',
  'tourist.pay': 'Pay',
  'tourist.tan.again': 'Get new code',
  'tourist.tan.': 'Packages',
  'tourist.choose': 'Choose SIM type',
  'tourist.choosen': 'SIM type',
  'tourist.connect': 'Connect your SIM card',
  'tourist.esim.guide':
    'You can check if your phone supports eSIM by referring to the listed models provided',
  'tourist.esim.warning':
    'Generate QR code and activate with smartphone camera or file saved as image',
  'tourist.verification': 'Sim verification',
  'tourist.qrsent': 'eSim receipt has been sent to your $email email',
  'tourist.select_device': 'Select a device',
  'tourist.selectType': 'Select SIM type',
  'tourist.self': 'Physical SIM',
  'tourist.self.guide':
    'You can activate your physical SIM by entering the 9-digit number found before the letter "F" on the back of your SIM card.',
  'tourist.self.warning': 'Install by entering the SIM card number',
  'tourist.tan.getagain': 'Get code again ',
  'tourist.tan_locked':
    'Tan code was entered incorrectly 3 times. Get new code.',
  'tourist.tan_creation_locked':
    'TAN code creation locked. Please try again after $.',
  'tourist.tan_mismatch': 'TAN code is incorrect',
  'tourist.tan_sent':
    'A verification code has been sent to your $email address',
  'tourist.tan_sent_phone':
    'A verification code has been sent to your $phoneNumber phone number',
  'tourist.warning':
    'Please select the type of SIM card to recover your number',
  'tourist.success': 'Registration successful',
  'tourist.success.desc':
    'Your SIM is ready for installation. Please insert it into your phone. Your phone number will be sent to your registered email shortly.',
  'tourist.recharge': 'Recharge',
  'tourist.number': 'Phone number',
  'tourist.number.enter': 'Enter your phone number',
  'tourist.number.find':
    'You can find your phone number in the email you received after activating your SIM.',
  'tourist.change': 'Change',
  'tourist.select': 'Select',
  'tourist.back': 'Back',
  'tourist.days': 'days',
  'tourist.day': 'day',
  'tourist.request.failed': 'Request failed.',
  'mobiai.header': 'mobiAI Премиум ',
  'mobiai.subheader': 'Ухаалаг датагаа аваад mobiAI Премиум үйлчилгээний Desktop Тохиргоог эндээс идэвхжүүлээрэй',
  'mobiai.ask': 'Энд дарна уу!',
  'verify.faceRecognition': 'Царай таниулах',
  'verify.faceRecognition.desc': 'Take pictures of both sides of your government issued ID card',
  'verify.emongolia.message.eer': 'мессежээр',
  'verify.emongolia.email': 'Имайл',
  'verify.emongolia.email.eer': 'имайлээр',
  'verify.emongolia.notification.eer': 'notification-ээр',
  'verify.sending': 'Илгээж байна ...',
  'verify.resending': 'Дахин илгээж байна...',
  'verify.resent': 'Дахин илгээсэн',
  'verify.resend': 'Дахин илгээх',
  'verify.invalidCode': 'Wrong Otp',
  'verify.codeExpired': 'Otp expired',
  'verify.tooManyAttempts': 'too many attempts',
  'verify.locked': 'locked',
  'verify.attemptsLeft': 'attemptsLeft',
  'verify.passport': 'Бичиг баримтаар',
  'verify.registerNumber': 'Регистрийн дугаараар',
  'verify.foreign.passport': 'Гадаад пасспорт',
  'verify.identity.card': 'Иргэний үнэмлэхээр',
  'verify.passport.type': 'Бичиг баримтийн төрөл',
  'verify.failed': 'ТАН код буруу байна',
  'mymobi.recommend.package': 'Танд санал болгох багцууд',
  'mymobi.own.package': 'Өөрийн багцыг бүтээх',
  'mymobi.month': 'Сард',
  'mymobi.data': 'дата',
  'mymobi.package': 'Багц',
  'mymobi.popular': 'Эрэлт ихтэй',
  'mymobi.unlimited': 'хязгааргүй',
  'mymobi.package.includes': 'VOO контент, Sonsy music streaming үйлчилгээ – багцад дагалдана.',
  'mymobi.bundles': 'Багцууд',
  'error.outstock.link': 'Энд',
  'verify.confirmation': 'Танин баталгаажуулах',
  'verify.emongolia': 'E-Mongolia баталгаажуулах',
  'verify.emongolia.desc': 'Нэг удаагийн код ашиглан хялбар баталгаажуулах боломжтой',
  'verify.regnoError': 'Таны регистрийн дугаар буруу байна. Та регистрийн дугаараа дахин шалгана уу',
  'verify.register.number': 'Регистрийн дугаараар баталгаажуулах',
  'verify.emongolia.notification': 'E-Mongolia мэдэгдэл',
  'verify.recommendation': 'Зөвлөмж:',
  'verify.recommendation.desc': 'Хэрэв та банкны эрх, тоон гарын үсгээр нэвтрэх бол e-Mongolia аппликэйшн татан нэвтэрч, мэдэгдэл сонголтоор баталгаажуулалт хийх боломжтой.',
  'verify.emongolia.message': 'Мессеж',
  'verify.verify': 'Баталгаажуулах',
  'verify.phoneNumberTest': 'Таны e-Mongolia бүртгэлд бүртгүүлсэн утасны дугаарт илгээсэн OTP кодыг оруулна уу.',
  'verify.emailTest': 'Таны E-Mongolia-д бүртгэлтэй майл хаягруу илгээсэн баталгаажуулах кодыг оруулна уу',
  'verify.appTest': 'Таны e-Mongolia аппликейшнээс мэдэгдлээр илгээсэн OTP кодыг оруулна уу.',
  'verify.success.info': 'Баталгаажуулалт амжилттай дууслаа',
  'mymobi.selected.customPackage': 'Сонгосон багц',
  'common.welcome': 'Тавтай морил',
  'common.submit': 'Илгээх',
  'common.cancel': 'Цуцлах',
  'common.save': 'Хадгалах',
  'common.delete': 'Устгах',
  'common.edit': 'Засах',
  'header.home': 'Нүүр',
  'header.promotions': 'Урамшуулал',
  'header.login': 'Нэвтрэх',
  'header.logout': 'Гарах',
  'header.profile': 'Миний мэдээлэл',
  'header.services': 'Үйлчилгээ',
  'header.information': 'Мэдээлэл',
  'header.store': 'Дэлгүүр',
  'header.fiveG': '5G',
  'footer.copyright': '© 2025 Mobicom. Бүх эрх хуулиар хамгаалагдсан.',
  'footer.privacy': 'Нууцлалын бодлого',
  'footer.about': 'Бидний тухай',
  'footer.introduction': 'Танилцуулга',
  'footer.managementTeam': 'Удирдлагын баг',
  'footer.socialResponsibility': 'Нийгмийн хариуцлага',
  'footer.coOperation': 'Хамтын ажиллагаа',
  'footer.career': 'Нээлттэй ажлын байр',
  'footer.logo': 'Лого',
  'footer.letUsHelpYou': 'Танд тусалъя',
  'footer.vatInfo': 'НӨАТ-ын мэдээлэл',
  'footer.findStore': 'Салбарын байршил',
  'footer.qa': 'Түгээмэл асуулт, хариулт',
  'footer.termsOfService': 'Үйлчилгээний нөхцөл',
  'footer.networkCoverage': 'Сүлжээний хамрах хүрээ',
  'footer.callCenter': 'Лавлах төв',
  'footer.domesticCall': 'Бусад сүлжээ',
  'footer.office': 'Оффис',
  'footer.fax': 'Факс',
  'footer.address': 'Хаяг',
  'footer.addressName':
    'Монгол Улс, Улаанбаатар хот, Сүхбаатар дүүрэг, 1-р хороо, ЮНЕСКО-ийн гудамж – 28, МПМ цогцолбор',
  'promotions.title': 'Урамшуулал',
  'promotions.viewDetails': 'Дэлгэрэнгүй үзэх',
  'promotions.category': 'Ангилал',
  'promotions.allCategories': 'Бүх ангилал',
  'promotions.noPromotions': 'Урамшуулал олдсонгүй',
  'promotions.newPhone': 'Шинэ дугаар',
  'promotions.onlyForYou': 'Зөвхөн танд',
  'promotions.dataPromotion': 'Дата',
  'promotions.phonePromotion': 'Онлайн дэлгүүр',
  'promotions.buy': 'Худалдан авах',
  'promotions.buttonActivate': 'Яг одоо идэвхжүүлэх',
  'promotions.days': 'хоног',
  'promotions.hours': 'цаг',
  'promotions.minutes': 'минут',
  'promotions.seconds': 'секунд',
  'promotions.expiresIn': 'Дуусахад',
  'promotions.activate': 'Идэвхжүүлэх',
  'promotions.share': 'Бусадтай хуваалцах',
  'promotions.end': 'Дуусах огноо',
  'promotions.getNewNumber': 'Шинэ дугаар авах',
  'promotions.chooseYourItem': 'Өөрийн сонголтоо хийнэ үү',
  'promotions.invalidIsdn': 'Утасны дугаар буруу байна',
  'promotions.gift': 'Бэлэгтэй',
  'promotions.sale': 'Хямдралтай',
  'promotions.multiply': 'Үржүүлдэг',
  'promotions.new': 'Шинэ',
  'promotions.hot': 'Эрэлттэй',
  'login.title': 'Нэвтрэх',
  'login.segment':
    'Таны сегментэд тохирсон урамшууллыг үзэхийн тулд хэрэглэгч сонгоно уу',
  'login.username': 'Хэрэглэгчийн нэр',
  'login.password': 'Нууц үг',
  'login.forgotPassword': 'Нууц үг мартсан?',
  'login.loginButton': 'Нэвтрэх',
  'login.noAccount': 'Бүртгэл байхгүй юу?',
  'login.register': 'Бүртгүүлэх',
  'login.prePaid': 'Урьдчилсан төлбөрт',
  'login.postPaid': 'Дараа төлбөрт',
  'login.hybrid': 'Хосолсон төлбөрт',
  'login.male': 'Эр',
  'login.female': 'Эм',
  'login.other': 'Бусад',
  'login.dataUsage': 'Дата хэрэглээ',
  'login.inactiveDays': 'Идэвхгүй хоног',
  'login.limitation': 'Хязгаарлалт',
  'login.arpu': 'ARPU',
  'pagination.previous': 'Өмнөх',
  'pagination.next': 'Дараах',
  'pagination.page': 'Хуудас',
  'pagination.of': '-ээс',
  'validation.required': 'Заавал бөглөнө үү',
  'validation.invalidEmail': 'И-мэйл хаяг буруу байна',
  'validation.minLength': 'Хамгийн багадаа {min} тэмдэгт байх ёстой',
  'validation.maxLength': 'Хамгийн ихдээ {max} тэмдэгт байх ёстой',
  'promotion.checkRatePlan': 'Уучлаарай та энэ урамшууллыг авах боломжгүй байна.',
  'verify.kyc.faceRecognition': 'Царай таниулан баталгаажуулах',
  'verify.kyc.faceRecognition.text': 'Нэг удаагийн кодны шаардлагагүй зөвхөн царайгаа таниулан баталгаажуулах боломжтой',
  'verify.kyc.faceRecognition.start': 'Царайг таниулах',
  'verify.kyc.faceRecognition.start.text': 'Та гар утасныхаа камерыг нээснээр бүртгэлээ баталгаажуулах боломжтой.',
  'verify.kyc.faceRecognition.guide': 'Царай таниулахад анхаарах зүйлс:',
  'verify.kyc.faceRecognition.guide.text1': 'Гэрэлтэй орчинд байх',
  'verify.kyc.faceRecognition.guide.text2': 'Царайг заасан тойрог дотор байрлуулах',
  'verify.kyc.faceRecognition.guide.text3': 'Малгай, шил болон нарны шил зүүгээгүй байх',
  'verify.kyc.faceRecognition.openCamera': 'Камер нээх',
  'verify.kyc.faceRecognition.tryAgain': 'Дахин оролдох',
  'verify.kyc.faceRecognition.permission.text': 'Үргэлжлүүлэхийн тулд камерын зөвшөөрөл олгоно уу. Хэрэв татгалзсан бол төхөөрөмжийнхөө тохиргооноос камерын зөвшөөрлийг идэвхжүүлээд дахин оролдоно уу.',
  'verify.kyc.faceRecognition.failed': 'Царай таниулалт амжилтгүй боллоо. Та царайгаа тод харагдах, гэрэл сайтай орчинд дахин оролдоно уу.',
  'verify.kyc.faceRecognition.failed.button': 'Ok',
  'verify.kyc.faceRecognition.failed.comparison':
    'Таны царай бүртгэлтэй мэдээлэлтэй тохирсонгүй. Та e-mongolia баталгаажуулалтаар бүртгэлээ баталгаажуулах боломжтой.',
  'verify.kyc.faceRecognition.failed.liveness':
    'Царай танилтаар баталгаажуулж чадсангүй. Дахин оролдоно уу.',
  'verify.kyc.faceRecognition.failed.tooManyAttempts':
    'Та нүүр танилцуулах оролдлогын дээд хязгаарт хүрлээ. Дараа дахин оролдох эсвэл өөр баталгаажуулалтын аргыг (e-Mongolia, салбар) ашиглана уу.',
  'verify.kyc.faceRecognition.text.hintTooFarText': 'Камераа ойртуулна уу.',
  'verify.kyc.faceRecognition.text.waitingCameraPermissionText': 'Камерын зөвшөөрөл хүлээж байна',
  'verify.kyc.faceRecognition.text.hintConnectingText': 'Холбогдож байна',
  'verify.kyc.faceRecognition.text.tooFarCaptionText': 'Камернаас хэт хол байна',
  'verify.kyc.faceRecognition.text.hintVerifyingText': 'Мэдээлэл шалгаж байна',
  'verify.kyc.faceRecognition.text.hintMoveFaceFrontOfCameraText': 'Царайгаа камерын өмнө байрлуулна уу.',
  'verify.kyc.faceRecognition.text.hintTooCloseText': 'Камераа холдуулна уу',
  'verify.kyc.faceRecognition.text.hintHoldFaceForFreshnessText': 'Хөдөлгөөнгүй барина уу',
  'menu.smart.usage': 'Smart Usage',
  'menu.smart.education': 'Smart Education',
  'vipshift.title': 'VIP Багц',
  'vipshift.subtitle': 'Багц ахиулах',
  'vipshift.package': 'VIP Багц',
  'vipshift.package.subtitle': 'VIP Багц',
  'vipshift.package.description': 'Танд VIP багцыг санал болгож байна.',
  'vipshift.package.description.subtitle': 'VIP Багц',
  'vipshift.package.description.description': 'VIP Багц',
  'vipshift.package.description.description.subtitle': 'VIP Багц',
  'vipshift.package.description.description.description': 'VIP Багц',
  'vipshift.activatePackages': 'Багц идэвхжүүлэх',
  'vipshift.activatePackages.subtitle': 'Багц идэвхжүүлэх',
  'vipshift.verifyPackage': 'Багц баталгаажуулах',
  'vipshift.verifyPackage.subtitle': 'Багц баталгаажуулах',
  'vipshift.terms': 'Үйлчилгээний нөхцөл',
  'vipshift.terms.subtitle': 'Үйлчилгээний нөхцөл',
  'vipshift.wait': 'Таны QR  түр   хугацаанд түгжигдсэн байна. Түр хүлээгээд дахин уншуулна уу.',
  'vipshift.used': 'QR код ашиглагдсан байна.',
  'vipshift.expired': 'QR хүчинтэй хугацаа дууссан байна.',
  'vipshift.info': 'Хэрвээ та VIP 199,000₮ багц руу шилжвэл эхний 3 сарын суурь хураамжаас 100% чөлөөлнө.',
  'vipshift.call.unlimited': 'Яриа хязгааргүй',
  'vipshift.data.unlimited': 'Дата хязгааргүй',
  'vipshift.sms.unlimited': 'Мессеж хязгааргүй',
  'family.service.data.share': 'Family үйлчилгээ дундаа ашиглах дата багц- 25GB',
  'hitone.cancel': 'Цуцлах',
  'hitone.save': 'Хадгалах',
  'hitone.config.numberConfig': 'Дугаарын тохиргоо',
  'hitone.config.numberConfig.allNumbers': 'Бүх дугаарт',
  'hitone.config.numberConfig.selectedNumbers': 'Зөвхөн доорх дугаар',
  'hitone.config.numberConfig.selectedNumbers.placeholder': 'Утасны дугаар оруулах',
  'hitone.config.numberConfig.selectedNumbers.guide': 'Утасны дугааруудыг таслалаар тусгаарлан оруулна уу?',
  'hitone.config.dayConfig': 'Өдрийн тохиргоо',
  'hitone.config.dayConfig.monday': 'Даваа',
  'hitone.config.dayConfig.tuesday': 'Мягмар',
  'hitone.config.dayConfig.wednesday': 'Лхагва',
  'hitone.config.dayConfig.thursday': 'Пүрэв',
  'hitone.config.dayConfig.friday': 'Баасан',
  'hitone.config.dayConfig.saturday': 'Бямба',
  'hitone.config.dayConfig.sunday': 'Ням',
  'hitone.config.clockConfig': 'Цагийн тохиргоо',
  'hitone.config.clockConfig.allTime': 'Бүх цагт тохируулах',
  'hitone.config.clockConfig.selectedTime': 'Сонгосон цагт тохируулах',
  'hitone.config.clockConfig.selectedTime.startTime': 'Эхлэх цаг',
  'hitone.config.clockConfig.selectedTime.endTime': 'Дуусах цаг',
  'hitone.config.clockConfig.selectedTime.guide': '0-23 цагийн хооронд оруулна уу (24 цагийн формат)',
  'hitone.songModal.unknownSong': 'Тодорхойгүй дуу байна.',
  'hitone.songModal.numberNotFound': 'Дугаар олдсонгүй.',
  'hitone.songModal.activateSuccess': 'Амжилттай идэвхжлээ.',
  'hitone.songModal.actionFailed': 'Амжилтгүй боллоо.',
  'hitone.songModal.notEnoughCredit': 'Нэгж хүрэлцэхгүй байна',
  'hitone.songModal.giftInvalidNumber': 'Бэлэглэх дугаар буруу байна.',
  'hitone.songModal.giftSuccess': 'Амжилттай бэлэглэлээ.',
  'hitone.songModal.verseOne': '1-р бадаг',
  'hitone.songModal.gift': 'Бэлэглэх',
  'hitone.songModal.activate': 'Миний цуглуулгад нэмэх',
  'hitone.songModal.free': 'Дууны үнэ 0₮',
  'hitone.songModal.activateFrom': '{date}-ээс эхлэн идэвхжинэ',
  'hitone.songModal.giftNumberLabel': 'Бэлэглэх дугаар',
  'hitone.songModal.continue': 'Үргэлжлүүлэх',
  'hitone.songModal.ok': 'OK',
  'hitone.songModal.serviceRequiredMessage': 'Контент идэвхжүүлэхийн тулд та HiTone үйлчилгээг идэвхжүүлсэн байх шаардлагатай.',
  'hitone.songModal.serviceRequiredConfirm': 'Авах',
  'hitone.songModal.serviceRequiredCancel': 'Болих',
  'hitone.saving': 'Хадгалж байна...',
  'hitone.collection.defaultTitle': 'Миний цуглуулга',
  'hitone.collection.addSong': 'Дуу нэмэх',
  'hitone.loading': 'Уншиж байна...',
  'hitone.empty': 'Хоосон байна',
  'hitone.song.fallbackName': 'Тодорхойгүй',
  'hitone.song.fallbackAuthor': 'Тодорхойгүй',
  'hitone.collection.yourSongs': 'Таны дуунууд',
  'hitone.search.placeholder': 'Дуу хайх',
  'hitone.collection.editTitle': 'Цуглуулга засах',
  'hitone.collection.namePlaceholder': 'Цуглуулгын нэрээ оруулна уу',
  'hitone.dialog.deleteSong.title': 'Дуу устгах',
  'hitone.dialog.deleteSong.description': 'Та энэ дууг жагсаалтаасаа хасахад итгэлтэй байна уу?',
  'hitone.dialog.deleteCollection.title': 'Цуглуулга устгах',
  'hitone.dialog.deleteCollection.description': 'Та энэ цуглуулгыг устгахдаа итгэлтэй байна уу?',
  'hitone.dialog.noToneToAdd.title': 'Нэмэх дуу алга',
  'hitone.dialog.noToneToAdd.description': 'Танд нэмэх идэвхжүүлсэн дуу алга байна.',
  'hitone.dialog.cancel': 'Үгүй',
  'hitone.dialog.confirm': 'Тийм',
  'hitone.icon.edit': 'Засах',
  'hitone.icon.play': 'Тоглуулах',
  'hitone.icon.search': 'Хайх',
  'hitone.icon.close': 'Хаах',
  'hitone.icon.save': 'Хадгалах',
  'hitone.icon.library': 'Сан',
  'hitone.icon.add': 'Нэмэх',
  'hitone.collections.title': 'HiTone',
  'hitone.collections.heroTitle': 'Таны HiTone',
  'hitone.collections.heroSubtitle': 'Идэвхтэй дуунуудаа эндээс хараарай',
  'hitone.collections.activeSongs': 'Идэвхтэй дуунууд',
  'hitone.collections.playlists': 'Дууны цуглуулга',
  'hitone.collections.libraryTitle': 'Таны сан',
  'hitone.collections.librarySubtitle': 'Идэвхтэй дуунуудаас өөрийн цуглуулгыг үүсгээрэй',
  'hitone.collections.favoriteTitle': 'Идэвхжүүлсэн дуунууд',
  'hitone.collections.songCount': 'дуу',
  'hitone.collections.createTitle': 'Цуглуулга үүсгэх',
  'hitone.collections.createSubtitle': 'Хүссэн дуунуудаа нэгтгэх',
  'hitone.collections.createSheetTitle': 'Шинэ цуглуулга',
  'hitone.collections.namePlaceholder': 'Цуглуулгын нэрээ оруулна уу',
  'hitone.featured.title': 'Онцлох HiTone',
  'hitone.library.defaultTitle': 'Цуглуулга',
  'hitone.icon.back': 'Буцах',
  'hitone.search.title': 'HiTone',
  'hitone.search.inputPlaceholder': 'Монгол дууны нэр',
  'hitone.search.byCategoryTitle': 'Дууны төрлөөр хайх',
  'hitone.search.byCategorySubtitle': 'Дууг хэв маягаар нь хайх',
  'hitone.search.noResults': 'Хайлт илэрцгүй байна',
  'hitone.home.title': 'HiTone',
  'hitone.home.featuredTitle': 'Онцлох HiTone',
  'hitone.home.newTitle': 'Шинээр нэмэгдсэн',
  'hitone.home.collectionsTitle': 'Дууны төрлүүд',
  'hitone.icon.more': 'Дэлгэрэнгүй',
  'location.permission.title': 'Таны байршлын мэдээлэлд хандахыг зөвшөөрөх үү?',
  'location.permission.description': 'Таны одоогийн байршлыг газрын зураг дээр харуулах болон ойролцоох хамрах хүрээг олохын тулд байршлын мэдээлэлд хандах шаардлагатай.',
  'location.permission.allow': 'Зөвшөөрөх',
  'location.permission.deny': 'Одоогоор үгүй',
  'location.error.unavailable': 'Байршил тогтооход алдаа гарлаа. Хөтчийн тохиргооноос зөвшөөрөл өгнө үү.',
  'location.error.unsupported': 'Таны хөтөч байршил тогтоохыг дэмждэггүй байна.',
  'location.error.permissionDenied': 'Зөвшөөрөл олгогдоогүй: Системийн тохиргоо (System Settings) -> Privacy & Security -> Location Services хэсгийг шалгаж, хөтөчдөө хандах эрх өгнө үү.',
  'location.error.positionUnavailable': 'Байршил тогтоох боломжгүй: Wi-Fi асаалттай байгаа эсэхийг шалгана уу.',
  'location.error.timeout': 'Хугацаа дууссан: Байршлыг хугацаанд нь тогтоож чадсангүй.',
  'location.error.httpsRequired': 'Байршил тогтоохын тулд HTTPS холболт шаардлагатай. Хөтчийн хаягийн мөрөнд "https://" эсвэл localhost ашиглана уу.',
  'map.layerLoadError': 'Сүлжээний мэдээллийг ачаалж чадсангүй.',
  'map.retry': 'Дахин оролдох',
  'family.stars': '0-14 насныханд зориулав',
  'family.error.text': 'Уучлаарай, энэ дугаарыг үүсгэх боломжгүй байна. Та өөрт ойр байрлах салбарт хандана уу.'
}

export default translations
